import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal, warningGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import { useNavigate } from "react-router-dom";


import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

const navigate = useNavigate;

// Add Evidence List
export const addEvidenceList = createAsyncThunk(
    'evidenceList/addEvidenceList',
    async(evidenceList, { dispatch }) => {
        try{
            const request = await axios.post(`/api/evidencesheet/create`, evidenceList, getAuthHeader());
            dispatch(successGlobal('Evidenčný list bol úspešne vytvorený.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
)

// Edit Evidence List
export const editEvidenceList = createAsyncThunk(
    'evidenceList/editEvidenceList',
    async(evidenceList, { dispatch }) => {
        try {
            const evidenceSheetId = evidenceList.evidenceSheetId._id;
            const request = await axios.patch(`/api/evidencesheet/${evidenceSheetId}/edit`, evidenceList, getAuthHeader());
            dispatch(successGlobal('Evidenčný list bol úspešne upravený.'));
            return request.data;
        } catch(error) {
            navigate('/evidenceList');
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
        }
    }
)

// Show all Evidence lists
export const fetchEvidenceList = createAsyncThunk(
    'evidenceList/fetchEvidenceList',
    async({ branchId, year, quarter } = {}, { dispatch }) => {
        try{
            const request = await axios.get(`/api/evidencesheet/showall`, {
                params: { branchId, year, quarter },
                ...getAuthHeader()
            });
            return request.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
)

// Show detailed Evidence List
export const getEvidenceList = createAsyncThunk(
    'evidenceList/getEvidenceList',
    async({id, currentBranch}, { dispatch }) => {

        try{
            const request = await axios.get(`/api/evidencesheet/${id}`, {
                params: { branchId: currentBranch },
                ...getAuthHeader()
            })

            return request.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'))
            throw error;
        }
    }
)

// Show available years
export const fetchAvailableYears = createAsyncThunk(
    'evidenceList/fetchAvailableYears',
    async({branchId, evidenceSheetId}, {dispatch}) => {
        try {
            const request = await axios.get(`/api/evidencesheet/${evidenceSheetId}/fetch-years`, {
                params: { branchId: branchId },
                ...getAuthHeader()
            })

            return request.data;

        } catch(error) {
            throw error;
        }
    }
)

// Export Evidence list to PDF format
export const exportToPDF = createAsyncThunk(
    'evidenceList/exportToPDF',
    async ({ id, branchId, year, month, day, quarter }, { dispatch }) => {
        try {
            const response = await axios.get(`/api/evidencesheet/${id}/generate-pdf`, {
                params: {
                    branchId,
                    year,
                    month,
                    day,
                    quarter
                },
                responseType: 'blob', // Specifying the blob response type for downloading a file
                ...getAuthHeader() // function return header with authorization
            });

            let periodLabel;
            if (day && month) periodLabel = `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}-${year}`;
            else if (quarter) periodLabel = `Q${quarter}-${year}`;
            else if (month) periodLabel = `${String(month).padStart(2, '0')}-${year}`;
            else periodLabel = `${year}`;

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Evidencny-list-${periodLabel}.pdf`;
            document.body.appendChild(a);
            a.click();

            const skippedMessage = response.headers['x-skipped-message'];
            if (skippedMessage) {
                dispatch(warningGlobal(decodeURIComponent(skippedMessage)));
            } else {
                dispatch(successGlobal('Evidenčný list odpadov bol úspšene exportované do PDF'));
            }

            // Open PDF in new tab or window
            window.open(url, '_blank');
            window.URL.revokeObjectURL(url);
            return { success: true }; 

        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Delete Evidence list
export const deleteEvidenceList = createAsyncThunk(
    'evidenceList/deleteEvidenceList',
    async({id, currentBranch, name}, {dispatch}) => {
        try {

            const response = await axios.delete(`/api/evidencesheet/${id}/delete`, {
                params: {
                    name,
                    branchId: currentBranch
                },
                ...getAuthHeader()
            });

            return { data: response.data, status: response.status };

        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Last Year Balance of evidence list
export const lastYearBalance = createAsyncThunk(
    'evidenceList/lastYearBalance',
    async({id, currentBranchId, year}, {dispatch}) => {
        try {
            
            const response = await axios.get(`/api/evidencesheet/${id}/last-year-balance`, {
                params: {
                    branchId: currentBranchId,
                    year
                },
                ...getAuthHeader()
            });

            return response.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Add Last year balance
export const addLastYearBalance = createAsyncThunk(
    'evidenceList/addLastYearBalance',
    async({id, currentBranchId, currentYear, numericLastYearBalance}, {dispatch}) => {
       
        try {
            const response = await axios.post(
                `/api/evidencesheet/${id}/create-last-year-balance`,
                {
                    branchId: currentBranchId,
                    date: `${currentYear}-01-01T10:00:00.000+00:00`,
                    income: numericLastYearBalance
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Zostatok z minulého roka bol úspešne pridaný.'));
            return response.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Get income and disposal
export const getIncomeDisposal = createAsyncThunk(
    'evidenceList/getIncomeDisposal',
    async({id, currentBranchId, year}, {dispatch}) => {
        try {

            const incomeDisposalResponse = await axios.get(`/api/evidencesheet/${id}/get-income-disposal` , {
                  params: {
                    branchId: currentBranchId,
                    year
                },
                ...getAuthHeader()
            });

            return incomeDisposalResponse.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
)